export class CloseableFirebaseWrapper {
    constructor(firebase) {
        this.unsubscribes = {};
        this.onDisconnectCancels = {};
        this.index = 0;
        this.firebase = firebase;
    }
    wrap(input) {
        const index = this.index;
        this.unsubscribes[index] = input;
        const res = () => {
            input();
            delete this.unsubscribes[index];
        };
        this.index++;
        return res;
    }
    onValue(path, callback) {
        return this.wrap(this.firebase.onValue(path, callback));
    }
    onChildAdded(path, callback) {
        return this.wrap(this.firebase.onChildAdded(path, callback));
    }
    onChildChanged(path, callback) {
        return this.wrap(this.firebase.onChildChanged(path, callback));
    }
    onChildRemoved(path, callback) {
        return this.wrap(this.firebase.onChildRemoved(path, callback));
    }
    set(path, value) {
        return this.firebase.set(path, value);
    }
    get(path) {
        return this.firebase.get(path);
    }
    runTransaction(path, transactionUpdate, options) {
        return this.firebase.runTransaction(path, transactionUpdate, options);
    }
    remove(path) {
        return this.firebase.remove(path);
    }
    // TODO: Determine if OnDisconnect should be cancelable.
    onDisconnect(path) {
        return this.firebase.onDisconnect(path);
    }
    update(path, values) {
        return this.firebase.update(path, values);
    }
    // onDisconnect(path: string): OnDisconnect {
    //     const input = this.firebase.onDisconnect(path);
    //     const cancel = input.cancel;
    //     const index = this.index;
    //     const wrapFn = (input: any) => {
    //         this.onDisconnectCancels[index] = cancel;
    //         return input();
    //     }
    //     const wrappedCancel = () => {
    //         delete this.onDisconnectCancels[index];
    //         return cancel();
    //     }
    //     this.index++;
    //     return {
    //         set: wrapFn(input.set),
    //         remove: wrapFn(input.remove),
    //         setWithPriority: wrapFn(input.setWithPriority),
    //         update: wrapFn(input.update),
    //         cancel: wrappedCancel,
    //     }
    // }
    close() {
        for (const unsubscribe of Object.values(this.unsubscribes)) {
            unsubscribe();
        }
        for (const cancel of Object.values(this.onDisconnectCancels)) {
            cancel();
        }
        this.unsubscribes = {};
        this.onDisconnectCancels = {};
    }
}
//# sourceMappingURL=CloseableFirebaseWrapper.js.map